/**
 * Created by minimus on 25.12.2014.
 */

(function ($) {
  const ejLocale = (options.locale.changeLocale) ? options.locale.locale : 'en-US';
  const localeStrings = options.strings;
  const moderateURI = options.samProAjaxModerate;

  $(document).ready(function () {
    let lis;
    const dm = ej.DataManager({
      url: `${ajaxurl}?action=load_ads&sam_pro_nonce=${options.samProNonce}`,
      removeUrl: `${ajaxurl}?action=remove_ad&sam_pro_nonce=${options.samProNonce}`,
      requestType: 'json',
      adaptor: new ej.UrlAdaptor()
    });

    const grid = $('#grid').ejGrid({
      dataSource: dm,
      locale: ejLocale,
      allowTextWrap: true,
      allowPaging: true,
      allowSorting: true,
      allowFiltering: true,
      filterSettings: {filterType: 'menu'},
      pageSettings: {pageSize: options.itemsPerPage},
      allowSelection: true,
      selectionSettings: {selectionMode: [ej.Grid.SelectionMode.Row], enableToggle: true},
      editSettings: {allowDeleting: true, showDeleteConfirmDialog : true},
      toolbarSettings: {
        showToolbar: true,
        toolbarItems: [
          ej.Grid.ToolBarItems.Delete
        ],
        customToolbarItems: [
          {templateID: '#viewMode'},
          'Refresh',
          {templateID: '#NewAd'},
          "Edit",
          {templateID: "#ModerateAd"},
          {templateID: "#UnModerateAd"},
          {templateID: "#TrashPlace"},
          {templateID: "#UnTrashPlace"}
        ]
      },
      toolbarClick: function (sender, args) {
        const tbarObj = $(sender.target);
        const rec = this.getSelectedRecords();
        let aid;
        if (tbarObj.hasClass("Refresh"))
          this.refreshContent();
        if(tbarObj.hasClass('Edit')) {
          if(rec.length > 0) {
            const item = rec[0].aid;
            document.location = options.editorUrl + item;
          }
        }
        else if (tbarObj.hasClass('place-to-trash') || tbarObj.hasClass('place-from-trash')) {
          const toFrom = ((tbarObj.hasClass('place-to-trash')) ? 1 : 0);
          if (rec.length > 0) {
            const trash = parseInt(rec[0].trash, 10);
            aid = parseInt(rec[0].aid, 10);
            if (trash !== toFrom) {
              $.post(ajaxurl, {
                action: 'trash_ad',
                aid: aid,
                trash: toFrom,
                sam_pro_nonce: options.samProNonce
              }).done((data) => {
                const sel = parseInt(ddList.getSelectedValue(), 10);
                if (sel === 0) grid._disabledToolItems.push(lis[8]);
                else if (sel === 1) grid._disabledToolItems.push(lis[7]);
                grid.refreshContent();
              });
            }
          }
        }
        else if(tbarObj.hasClass('ad-moderate') || tbarObj.hasClass('ad-unmoderate')) {
          const mod = ((tbarObj.hasClass('ad-moderate')) ? 1 : 0);
          if(rec.length > 0) {
            const moderated = parseInt(rec[0].moderated, 10);

            aid = parseInt(rec[0].aid, 10);
            if(moderated !== mod) {
              $.post(moderateURI, {
                action: 'moderate_ad',
                aid: aid,
                mod: mod,
                sam_pro_nonce: options.samProNonce
              }).done(() => {
                grid.refreshContent();
              });
            }
          }
        }
      },
      create: function (args) {
        const $toolbar = $('#grid_toolbarItems');
        lis = $toolbar.find("li");
        $('.place-to-trash').parent('li').attr('title', localeStrings.moveToTrash);
        $('.place-from-trash').parent('li').attr('title', localeStrings.restoreFromTrash);
        $('.ad-moderate').parent('li').attr('title', localeStrings.approve);
        $('.ad-unmoderate').parent('li').attr('title', localeStrings.cancelApproval);
        $('#view-mode').parent('li').attr('title', localeStrings.viewMode);
        $('li[title="NewAd"]').attr('title', localeStrings.newAd);
        $('li[title="Edit"]').attr('title', localeStrings.edit);
        $('.Refresh').parent('li').attr('title', localeStrings.refresh);
      },
      actionComplete: function(args) {
        if (args.requestType === 'refresh') {
          const $tb = $('#grid_toolbarItems');
          let li;
          li = $('#grid_delete');
          $tb.ejToolbar('disableItem', li);
          li = $('#grid_Edit');
          $tb.ejToolbar('disableItem', li);
          li = $('#grid_ModerateAd');
          $tb.ejToolbar('disableItem', li);
          li = $('#grid_UnModerateAd');
          $tb.ejToolbar('disableItem', li);
          li = $('#grid_TrashPlace');
          $tb.ejToolbar('disableItem', li);
          li = $('#grid_UnTrashPlace');
          $tb.ejToolbar('disableItem', li);
        }
      },
      recordClick: function(args) {
        const $tb = $('#grid_toolbarItems');
        let li;
        const recs = this.getSelectedRecords();
        const action = (recs.length === 0) ? 'disableItem' : 'enableItem';
        li = $('#grid_delete');
        $tb.ejToolbar(action, li);
        li = $('#grid_Edit');
        $tb.ejToolbar(action, li);
        li = $('#grid_ModerateAd');
        $tb.ejToolbar(action, li);
        li = $('#grid_UnModerateAd');
        $tb.ejToolbar(action, li);
        li = $('#grid_TrashPlace');
        $tb.ejToolbar(action, li);
        li = $('#grid_UnTrashPlace');
        $tb.ejToolbar(action, li);
      },
      columns: [
        {field: 'aid', headerText: localeStrings.adId, isPrimaryKey: true, textAlign: ej.TextAlign.Right, allowSorting: true, allowEditing: false, width: 100},
        {field: 'title', headerText: localeStrings.name, allowSorting: true, allowEditing: false, width: 250},
        {field: 'description', headerText: localeStrings.desc, allowSorting: true, allowEditing: false},
        {field: 'asize', headerText: localeStrings.size, allowSorting: true, allowEditing: false, width: 100},
        {field: 'stat', headerText: localeStrings.status, textAlign: ej.TextAlign.Center, allowSorting: false, allowEditing: false, allowFiltering: false, width: 100},
        {field: 'trash', headerText: 'Status', allowEditing: false, visible: false}
      ]
    }).data('ejGrid');

    const ddList = $('#view-mode').ejDropDownList({
      selectedItemIndex: 0,
      change: function (args) {
        const sel = parseInt(this.getSelectedValue(), 10);
        if (sel !== 10) {
          $('#grid').ejGrid('model.query', new ej.Query().where('trash', ej.FilterOperators.equal, sel, 10));
        }
        else {
          $('#grid').ejGrid('model.query', new ej.Query());
        }
        if (sel === 0) grid._disabledToolItems.push(lis[8]);
        else if (sel === 1) grid._disabledToolItems.push(lis[7]);
        grid.refreshContent(true);
      }
    }).data('ejDropDownList');
  });
})(jQuery);
